import React, { useMemo } from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { useWixPriceUIContext } from "./WixPriceUIContext";
import { WixPriceTable } from "./wix-price-table/WixPriceTable";
// import { CartPriceTable } from "./cart-price-table/CartPriceTable";

export default function WixPriceCard() {
  
  const priceUIContext = useWixPriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      newPriceButtonClick: priceUIContext.newPriceButtonClick,
    };
  }, [priceUIContext]);

  return (
    <Card>
      <CardHeader title='Wix Price'>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={priceUIProps.newPriceButtonClick}>
            <i className="fas fa-plus-circle"></i> Add New Plan
          </button>
        </CardHeaderToolbar>
      </CardHeader>{" "}  
      <CardBody>
        <WixPriceTable/>
      </CardBody>
    </Card>
  );
}
